/**
 * @file paddlejs modelService
 * @author wanzhongyun
 */

import React from 'react';
import { IPaddleJsModelService } from './../../type';

import './style.less';


const PaddleJSModelService: React.FC<IPaddleJsModelService> = props => {

    const { title, desc, ImageUrl } = props;

    return <div className='paddle-js-model-service-wrapper'>
        <div className='paddle-js-model-service-title'>{ title }</div>
        <div className='paddle-js-model-service-desc'>{ desc }</div>
        <img className='paddle-js-model-service-image' src={ImageUrl} alt='' />
    </div>
};

export default PaddleJSModelService;